import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';
import { URLS_GUARD } from '../models/url-guard.enum';

@Injectable({
	providedIn: 'root'
})
export class RedirectGuardService implements CanActivate {
	readonly #authService = inject(AuthService);
	readonly #router = inject(Router);
	count = 5;

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
		return this.redirectToCorrectUrl(state);
	}

	redirectToCorrectUrl(state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
		if(!this.#authService.getTokenValue && this.count > 0){
			this.count--;
			setTimeout(() => {
				return this.redirectToCorrectUrl(state);
			}, 1000);
		} else {
			if (state.url.indexOf(`/${URLS_GUARD.COMPANY}`) === 0 && this.#authService.isCompany()) {
				//Case url corretto Company
				return true;
			} else if(state.url.indexOf(`/${URLS_GUARD.PHOTOGRAPHER}`) === 0 && this.#authService.isPhotographer()){
				//Case url corretto Photographer
				return true;
			} else {
				//Case url errato
				const url = this.#authService.isCompany() ? URLS_GUARD.COMPANY : URLS_GUARD.PHOTOGRAPHER;
				return this.#router.createUrlTree([url]);
			}
		}
	}
}
